<nav class="navbar navbar-expand-xl navbar-light fixed-top hk-navbar">
    <button type="button" class="navbar-brand navbar-brand-button" (click)="toMainPage()">
        <img class="brand-img d-inline-block" src="/assets/img/logo.png" alt="brand"/>
    </button>
    <ul class="navbar-nav hk-navbar-content mr-40">
        <li class="nav-item dropdown pointer d-flex align-items-center" [class.show]="dropdownOpen">

            <div class="d-flex align-items-center user-dropdown-toggle" (click)="toggleDropdown($event)">
                <img [src]="imgSrc" alt="user" class="rounded-circle" width="30" height="30"/>
                <span class="mx-2">{{ username }}</span>
                <em class="fa fa-chevron-down"></em>
            </div>

            <ul class="dropdown-menu show-on-side" [class.show]="dropdownOpen">
                <li class="dropdown-item">
                    <a class="dropdown-item" href="{{link}}">
                        <span class="d-inline-block mr-2">
                            <em class="fa fa-cog" aria-hidden="true"></em>
                        </span>
                        <span translate>navbar.profile</span>
                    </a>
                </li>
                <li class="dropdown-item">
                    <button type="button" class="dropdown-item dropdown-action-button" (click)="logout()">
                        <span class="d-inline-block mr-2">
                        <em class="fa fa-power-off" aria-hidden="true"></em>
                        </span>
                        <span translate>navbar.logout</span>
                    </button>

                </li>
                <li>
                    <p class="text-right mt-3 mr-2"><small><span translate>navbar.version</span> {{buildVersion}}</small></p>
                </li>
            </ul>
        </li>
        <li class="nav-item dropdown pointer language-dropdown-placeholder">
<!--            <a class="nav-link dropdown-toggle" id="dropdownMenuLanguage" data-bs-toggle="dropdown"-->
<!--               aria-expanded="false">-->
<!--                <span class="text-uppercase">-->
<!--                    {{currentLanguage}}-->
<!--                </span>-->
<!--            </a>-->
<!--            <ul class="dropdown-menu pull-left" aria-labelledby="dropdownMenuLanguage">-->
<!--                <li *ngFor="let language of languages">-->
<!--                    <a class="dropdown-item" (click)="changeLanguage(language.code)">-->
<!--                        <em class="dropdown-icon zmdi zmdi-globe"></em>-->
<!--                        <span>{{ language.label }}</span>-->
<!--                    </a>-->
<!--                </li>-->
<!--            </ul>-->
        </li>
        <li *ngIf="false" class="nav-item dropdown dropdown-notifications">
            <a class="nav-link dropdown-toggle no-caret" href="#" role="button" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
                <em class="fa fa-bell"></em>
            </a>
            <div class="dropdown-menu dropdown-menu-right" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut">
                <h6 class="dropdown-header" translate>navbar.notifications</h6>
            </div>
        </li>
        <li *ngIf="false" class="nav-item dropdown dropdown-email">
            <a class="nav-link dropdown-toggle no-caret" href="#" role="button" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
                <span class="">
                    <em class="fa fa-envelope"></em>
                </span>
            </a>
        </li>
    </ul>
</nav>
